import React from "react";
import scriptLoader from "react-async-script-loader";
import { settings } from "../../../../config/settings"
import ControlService from "../../../controlservice";
import Loading from '../../Loading'


function bindAction(dispatch) {
    return {
    };
}
class Elavon extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            transactionToken: null,
            isApiCalling: false,
            responsefields: '',
            data: {}
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        var data = nextProps.data[nextProps.formid] ? nextProps.data[nextProps.formid] : {}
        if (JSON.stringify(data) != JSON.stringify(prevState.data)) {
            return {
                data: data,
            };
        } else return null; // Triggers no change in the state
    }
    componentDidMount() {
        debugger;
        this.initPayment();
    }
    componentDidUpdate(prevProps, prevState) {
        if (JSON.stringify(this.state.data) != JSON.stringify(prevState.data)) {
            this.initPayment(prevState.data);
        }
    }
    initPayment(prevData) {
        const { control } = this.props;
        const { data } = this.state;
        if (Array.isArray(control.responsefield) && control.responsefield.length > 0) {
            var QueryStr = control.responsefield
                .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(data[k]))
                .join('&');
            this.setState({ responsefields: QueryStr });
        }
        if (data && prevData && data[control.amountfield] != prevData[control.amountfield]) {
            this.initiateTransactionToken(control, data);
        }
    }
    initiateTransactionToken(control, data) {
        this.setState({ isApiCalling: true });
        var apiParam = {
            id: 'menu',
            amount: data[control.amountfield] ? data[control.amountfield] : ''
        };
        Array.isArray(control.additionalfield) && control.additionalfield.forEach(field => {
            apiParam[field] = data[field];
        });
        let _control = {
            method: 'get',
            datasource: 'http'
        }
        let url = settings.ELAVON_PAY_TOKEN;
        if (this.props.token.ExtFunctionEndpoint) {
            url = this.props.token.ExtFunctionEndpoint + url;
        } else {
            url = process.env.REACT_APP_AZURE_FUNCTION_ENDPOINT + url;
        }
        ControlService().ServiceRequest(url, apiParam, _control, this.props.token).then(_data => {
            if (_data.data.includes('The application has encountered an')) {
                console.log(_data.data);
                this.setState({ isApiCalling: false });
            } else {
                this.setState({ transactionToken: _data.data, isApiCalling: false }, () => this.launchOnLoad(control, data.data));
            }
        });
    }
    launchOnLoad(control, transactionToken) {
        if (control.paymentlaunch === 'onload') {
            window.open(('https://api.convergepay.com/hosted-payments?ssl_txn_auth_token=' + transactionToken + "&" + this.state.responsefields), '_self')
        }
    }
    launchOnClick(control, transactionToken) {
        if (control.redirecttype == 'newtab') {
            window.open(('https://api.convergepay.com/hosted-payments?ssl_txn_auth_token=' + transactionToken + "&" + this.state.responsefields), '_blank');
        } else if (control.redirecttype == 'window') {
            window.open(('https://api.convergepay.com/hosted-payments?ssl_txn_auth_token=' + transactionToken + "&" + this.state.responsefields), '_blank'
                , 'toolbar=yes,scrollbars=yes,resizable=yes,top=50,left=100,width=1200,height=700');
        } else {
            window.open(('https://api.convergepay.com/hosted-payments?ssl_txn_auth_token=' + transactionToken + "&" + this.state.responsefields), '_self');
        }
    }
    render() {
        const { transactionToken, isApiCalling } = this.state;
        const { control, formid } = this.props;
        var data = this.props.data[formid] ? this.props.data[formid] : {};
        var customStyle = {};
        if (control.styles) {
            try {
                customStyle = JSON.parse(control.styles);
            } catch {
                customStyle = {};
            }
        }
        if (isApiCalling) {
            return <Loading token={this.props.token} />
        } else if (control.paymentlaunch !== 'onload') {
            return (
                <button data-tip data-for={control.id} onClick={(e) => {
                    e.preventDefault();
                    this.launchOnClick(control, transactionToken);
                }}
                    disabled={transactionToken ? false : true}
                    className={' btn ' + control.coutomClass + ' btn-' + control.buttontype + ' btn-' + control.size}
                    style={customStyle}
                >
                    {control.WebIcon &&
                        <i className={control.WebIcon + (control.label ? ' mr-2' : '')}></i>
                    }
                    {control.bindbuttonlabelwithdata ? data[control.key] : control.label}

                </button>
            )
        } else return null;
    }
}

export default Elavon;